import React, { useEffect, useState } from "react";
import { Col, Row, Modal, ModalBody, Input, Label, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
//Job Images
import jobImage1 from "../../../assets/images/featured-job/img-01.png";
import jobImage2 from "../../../assets/images/featured-job/img-02.png";
import jobImage3 from "../../../assets/images/featured-job/img-03.png";
import jobImage4 from "../../../assets/images/featured-job/img-04.png";
import { get } from "../../../utils/apiUtil";
import ApplyFobJobModal from "../../../components/ApplyForJobModal";
import Pagination from "../JobList2/Pagination";

const JobVacancy = ({ filter }) => {
    //Apply Now Model
    const [modal, setModal] = useState(false);
    const openModal = () => setModal(!modal);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobs, setJobs] = useState([]);

    const [jobVacancy, setJobVacancy] = useState([]);

    const getAllJobs = async () => {
        setIsLoading(true);
        try {
            const response = await get('/get-all-jobs');
            // setJobs(response.data);
            setJobVacancy(transformJobs(response.data));
        } catch (error) {
            if (error.status === 404) {
                setShowError(true);
                return;
            }
            alert(error?.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    }

    const getJobsByType = (jobType) => {
        return jobs?.filter(job => job.JobType.toLowerCase() === jobType.toLowerCase());
    };

    const fallbackImage = "https://t4.ftcdn.net/jpg/06/71/92/37/360_F_671923740_x0zOL3OIuUAnSF6sr7PuznCI5bQFKhI0.jpg";
    const badgeClassPool = [
        { bg: "bg-primary-subtle", text: "text-primary" },
        { bg: "bg-success-subtle", text: "text-success" },
        { bg: "bg-danger-subtle", text: "text-danger" },
        { bg: "bg-warning-subtle", text: "text-warning" },
        { bg: "bg-info-subtle", text: "text-info" },
        { bg: "bg-secondary-subtle", text: "text-secondary" }
    ];

    const getColorClassForSkill = (skill) => {
        const hash = [...skill].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const index = hash % badgeClassPool.length;
        return badgeClassPool[index];
    };

    const transformJobsOld = (data) => {
        return data.map((job, index) => {
            // Pick a random badge style from the pool
            const randomBadge = badgeClassPool[index % badgeClassPool.length];

            // Build badges array
            const badges = [
                {
                    id: 1,
                    badgeclassName: `${randomBadge.bg} ${randomBadge.text}`,
                    badgeName: job.EmployeeType || "General"
                }
            ];

            return {
                id: job.ID,
                companyImg: job.CompanyLogo || fallbackImage,
                jobDescription: job.JobTitle || "Untitled Job",
                experience: job.ExperienceRequired || "N/A",
                companyName: job.CompanyName || "Unnamed Company",
                location: job.JobLocation || "Unknown",
                salary: job.OfferSalary || "N/A",
                JobType: job.JobType,
                timing: job.JobType || "N/A",
                addclassNameBookmark: index % 2 === 0, // Toggle or apply real condition
                badges
            };
        });
    }

    const transformJobs = (data) => {
        // Filter jobs if params are present
        const filtered = data.filter((job) => {
            const matchesJobType = filter.jobType
                ? job.JobCategory?.toLowerCase() === filter.jobType?.toLowerCase()
                : true;

            const matchesState = filter.state
                ? job.State?.toLowerCase() === filter.state?.toLowerCase()
                : true;

            return matchesJobType && matchesState;
        });

        return filtered.map((job, index) => {
            const randomBadge = badgeClassPool[index % badgeClassPool.length];

            const badges = [
                {
                    id: 1,
                    badgeclassName: `${randomBadge.bg} ${randomBadge.text}`,
                    badgeName: job.EmployeeType || "General"
                }
            ];

            return {
                id: job.ID,
                companyImg: job.CompanyLogo || fallbackImage,
                jobDescription: job.JobTitle || "Untitled Job",
                experience: job.ExperienceRequired || "N/A",
                companyName: job.CompanyName || "Unnamed Company",
                location: job.JobLocation || "Unknown",
                salary: job.OfferSalary || "N/A",
                JobType: job.JobType,
                timing: job.JobType || "N/A",
                addclassNameBookmark: index % 2 === 0,
                badges
            };
        });
    };

    useEffect(() => {
        getAllJobs();
    }, [filter]);

    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setIsModalOpen(true);
    };

    return (
        <React.Fragment>
            {showError ? (
                <Alert color="danger mt-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    No jobs found.
                </Alert>
            ) : (<>
                <Row>
                    {jobVacancy.map((jobVacancyDetails, key) => (
                        <Col lg={6} key={key}>
                            <div
                                className={
                                    jobVacancyDetails.addclassNameBookmark === true
                                        ? "job-box bookmark-post card mt-4"
                                        : "job-box card mt-4"
                                }
                            >
                                <div className="p-4">
                                    <Row>
                                        <Col lg={2}>
                                            <Link to="/companydetails">
                                                <img
                                                    src={jobVacancyDetails.companyImg}
                                                    alt=""
                                                    className="img-fluid rounded-3"
                                                />
                                            </Link>
                                        </Col>
                                        <Col lg={10}>
                                            <div className="mt-3 mt-lg-0">
                                                <h5 className="fs-17 mb-2">
                                                    <Link to={`/job-details/${jobVacancyDetails.id}`} className="text-dark">
                                                        {jobVacancyDetails.jobDescription}
                                                    </Link>
                                                </h5>
                                                <ul className="list-inline mb-2">
                                                    <li className="list-inline-item">
                                                        <p className="text-muted fs-14 mb-0">
                                                            {jobVacancyDetails.companyName}
                                                        </p>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <p className="text-muted fs-14 mb-0">
                                                            <i className="mdi mdi-map-marker"></i>{" "}
                                                            {jobVacancyDetails.location}
                                                        </p>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <p className="text-muted fs-14 mb-0">
                                                            <i className="uil uil-wallet"></i>{" "}
                                                            {jobVacancyDetails.salary}
                                                        </p>
                                                    </li>
                                                </ul>
                                                <div className="mt-2">
                                                    <span
                                                        className={
                                                            jobVacancyDetails.JobType === 'Full Time'
                                                                ? "badge bg-secondary-subtle text-secondary fs-13 mt-1 mx-1"
                                                                : "badge bg-primary-subtle text-primary fs-13 mt-1 mx-1"
                                                        }
                                                    >
                                                        {jobVacancyDetails.timing}
                                                    </span>
                                                    {(jobVacancyDetails.badges || []).map((badgeInner, key) => (
                                                        <span
                                                            className={`badge ${badgeInner.badgeclassName} fs-13 mt-1`}
                                                            key={key}
                                                        >
                                                            {badgeInner.badgeName}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="favorite-icon">
                                        <Link to="#">
                                            <i className="uil uil-heart-alt fs-18"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div className="p-3 bg-light">
                                    <Row className="justify-content-between">
                                        <Col md={8}>
                                            <div>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <i className="uil uil-tag"></i> Experience:
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link to="#" className="primary-link text-muted">
                                                            {jobVacancyDetails.experience}
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="text-md-end">
                                                <Link
                                                    to="#applyNow"
                                                    onClick={() => handleApplyClick(jobVacancyDetails)}
                                                    className="primary-link"
                                                >
                                                    Apply Now <i className="mdi mdi-chevron-double-right"></i>
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Pagination />
                <ApplyFobJobModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    job={selectedJob}
                />
            </>
            )}
        </React.Fragment>
    );
};

export default JobVacancy;
